import { Equipment, ComponentId, EquipmentType } from '../../../models';
import { Site } from '../../../models/site';

const equipmentList = [ComponentId.Storage, ComponentId.Inverter];
export const useEquipment = (site: Site) => {
  const result = equipmentList.reduce((acc, equipmentType) => {
    const groupedEquipment = site.nodes.reduce((acc, node) => {
      const filteredEquipment = node.equipment.filter(
        (siteEquipment) =>
          siteEquipment.equipmentType === (ComponentId[equipmentType] as unknown as EquipmentType) // TODO: check this type
      );

      filteredEquipment.forEach((equipment) => {
        const existingGroup = acc.find((group) => group[0].model === equipment.model);
        if (existingGroup) {
          existingGroup.push(equipment);
        } else {
          acc.push([equipment]);
        }
      });

      return acc;
    }, [] as Equipment[][]);

    return {
      ...acc,
      [equipmentType]: groupedEquipment,
    };
  }, {} as Record<ComponentId, Equipment[][]>);

  return result;
};
